/**
 * Returns the number of scenarios based on calculatorSize
 * @param {number} calculatorSize
 */
function getScenarioCount(calculatorSize) {
    // Arbitrary breakpoints for now
    if (calculatorSize <= 400) { // small - 1 column
        return 1;
    }

    if (calculatorSize <= 600) { // medium - 2 column
        return 2;
    }

    if (calculatorSize <= 800) { // large - 3 column
        return 3;
    }

    // full - 4 column
    return 4;
}

export default getScenarioCount;